import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { initGA } from '@/utils/analytics';

export const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const choice = localStorage.getItem('cookie_consent');
    if (!choice) {
      setVisible(true);
    } else if (choice === 'accepted') {
      initGA();
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setVisible(false);
    initGA();
  };

  const handleDecline = () => {
    localStorage.setItem('cookie_consent', 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 px-4 py-4 shadow-lg" style={{ background: 'var(--hj-surface-1)', borderTop: '1px solid var(--hj-hairline)' }}>
      <div className="container mx-auto max-w-4xl flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-sm text-center sm:text-left" style={{ color: 'var(--hj-ink-2)' }}>
          We use cookies to improve your experience and analyze site traffic.
        </p>
        <div className="flex gap-3 shrink-0">
          <Button
            variant="outline"
            size="sm"
            onClick={handleDecline}
            style={{ borderColor: 'var(--hj-hairline)', color: 'var(--hj-ink-2)' }}
          >
            Decline
          </Button>
          <Button
            size="sm"
            onClick={handleAccept}
          >
            Accept
          </Button>
        </div>
      </div>
    </div>
  );
};
